import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import SlideShow from '../components/SlideShow';
import TopSingersHome from '../components/TopSongHome';

const Home = ()=>{
    return(
    <div>
      <Navbar/>
      <SlideShow/>
      <TopSingersHome/>
      <Footer/>
    </div>
    )
}

export default Home;